import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import BaseModal from './BaseModal';
import { inputTypes } from '../../utils/inputTypes';
import ModalForm from './ModalForm';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { createNew, editTerminal, loadStatusesAsync } from '../../actions/terminalActions'
import { showSnackbar, closeSnackbar } from "../../actions/snackbarActions";
import ApiService from '../../services/api';
import { loadCompaniesAsync } from "../../actions/companyActions";
import { loadPumpsAsync } from "../../actions/stationActions";


const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
});

class TerminalModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      formFields: []
    }
    this.apiService = new ApiService();
  }

  async componentDidMount() {

    const statuses = (await this.props.loadStatusesAsync()) || [];
    let companies = (await this.props.loadCompaniesAsync()) || [];
    let pumps = (await this.props.loadPumpsAsync()) || [];

    companies = companies.map(l => ({ value: l, label: l.name }))
    pumps = pumps.map(p => ( {value: p, label: `${p.stationCode}, ${p.name}, ${p.pumpNumber}` }));
    const locations = [...companies, ...pumps];

    // Array of inputs that dynamically build
    // up the editor form.
    let formFields = [
      {
        id: "terminalCode",
        name: "terminalCode",
        label: "Terminal Code",
        type: inputTypes.textField
      },
      {
        id: "statusId",
        name: "statusId",
        label: "Status",
        type: inputTypes.select,
        options: statuses
      },
      {
        id: "locationId",
        name: "locationId",
        label: "Location",
        type: inputTypes.autoComplete,
        entities: locations
      },
      {
        id: "comment",
        name: "comment",
        label: "Comment",
        type: inputTypes.textField
      }
    ];
    
    this.setState({
      formFields: formFields
    })
    //Debugging: simulated delay
    /*
    var that = this;
    setTimeout(function() {
      that.update(formFields);
    }, 10000);
    */
  }
  /*
  Debugging: help-funcion
  update = (formFields) => {
    this.setState({
      formFields: formFields
    })
  }*/

  // This function is called by the child component
  // (<BaseModal>) during its own submit function
  onSubmit = async (values) => {
    // Different action needs to be fired, depending on
    // whether creating new company or editing one.
    if (this.props.isEdit && this.props.selectedTerminal) {
      const id = this.props.selectedTerminal.id;
      const editedTerminal = { ...values, id };
      await this.props.editTerminal(editedTerminal);
      this.props.showSnackbar("Terminal edited");

    } else {
      await this.props.createNew(values);
      this.props.showSnackbar("New terminal created");
    }
  }


  render() {
    const {isOpen, handleClose, isEdit, selectedTerminal } = this.props;
    let terminalCodes = this.props.terminalCodes;
    if(isEdit && this.props.selectedTerminal) {
      terminalCodes = this.props.terminalCodes.filter(x => x !== this.props.selectedTerminal.terminalCode);
    }
  // Validation schema can be difficult to build dynamically
  // in the child component. For easiness, it's created here
  // and then passed down as prop
   const validationSchema = Yup.object().shape({
    terminalCode: Yup.string()
    .notOneOf(terminalCodes, "Terminal Code must be unique")
    .test("has-white-space", "No spaces allowed.", value => /\s/g.test(value) === false)
      .label("Serial Number")
      .required(),
      statusId: Yup.string()
      .label("Part Type")
      .required()
      .min(1),
      comment: Yup.string()
      .label("Comment")
  });

    return (
      <BaseModal isEdit={isEdit} modalType="Terminal"  onSubmit={this.onSubmit} isOpen={isOpen} handleClose={handleClose}>
        <ModalForm validationSchema={validationSchema} initialValues={selectedTerminal} formFields={this.state.formFields} handleCancel={handleClose}>
        </ModalForm>
      </BaseModal>
    )
  }
}
export default
  compose(
    withStyles(styles),
    connect(null, { createNew, editTerminal, showSnackbar, closeSnackbar, loadStatusesAsync, loadCompaniesAsync, loadPumpsAsync })
  )(TerminalModal);



// WEBPACK FOOTER //
// ./src/components/Modals/TerminalModal.js